import { useQuery } from "@tanstack/react-query";
import { getBankingAccounts } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const BANKING_ACCOUNTS_QUERY_KEY = "BANKING_ACCOUNTS";

export const bankingAccountsKeys = {
  all: [BANKING_ACCOUNTS_QUERY_KEY],
  lists: () => [...bankingAccountsKeys.all, "list"],
  listByUserID: (userID?: number) => [...bankingAccountsKeys.lists(), userID],
};

/**
 * Pass `userID` only when viewing ANOTHER user's accounts (admin views) — it
 * forks the cache per user. For the current user's own accounts always omit
 * it, so every self-view consumer shares the one no-arg cache entry.
 */
export const useBankingAccounts = (userID?: number, enabled = true) =>
  useQuery({
    queryKey: bankingAccountsKeys.listByUserID(userID),
    queryFn: processResponseWithApiProblemDetails(() =>
      getBankingAccounts(userID),
    ),
    staleTime: 1000 * 60 * 1, // 1 minute
    enabled,
  });
